var React = require('react');

function IconRadioSelected (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"8","cy":"8","r":"7.5","fill":"white","key":0}),React.createElement("path",{"d":"M3 8C3 5.24 5.24 3 8 3C10.76 3 13 5.24 13 8C13 10.76 10.76 13 8 13C5.24 13 3 10.76 3 8Z","key":1})]);
}

IconRadioSelected.defaultProps = {"viewBox":"0 0 16 16","fill":"none"};

module.exports = IconRadioSelected;

IconRadioSelected.default = IconRadioSelected;
